require('matchmedia-polyfill');
require('matchmedia-polyfill/matchMedia.addListener');
import './polyfill'
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'core-js/es6/map';
import 'core-js/es6/array';
import 'core-js/es6/set';
import 'core-js/es6/promise';
import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import SiteIndex from './site/index';
import {Provider} from 'react-redux';
import store from './site/store';
import {HashRouter as Router, Route} from 'react-router-dom';
import history from './site/routing/history';
import favicon from "file-loader!../src/images/myfavicon.ico";
import bg from "file-loader!./site/source/images/bg.png";

 document.querySelector('link[rel="icon"]').href = favicon;//动态设置标题图标
 document.getElementById('baseBody').style.backgroundImage = `url(${bg})`;
 document.getElementById('baseBody').style.backgroundSize = "100% 100%";
ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Route component={SiteIndex} /> {/* 没有 path 就会匹配所有路由 */}
        </Router>
    </Provider>,
    document.getElementById('app')
);
